import { CampaignSubTypeMapping } from '@bingads-webui-campaign-react/constants';

/**
 * if current campaign is smart shopping campaign and user is in ad group level
 * there should be no ad group settings page
 * however the scope service seems not do the redirect automatically so we have to do it manually
 * @param {Scope} scope scope
 * @param {Campaign} currentCampaign currentCampaign
 * @param {AdGroup} currentAdGroup currentAdGroup
 * @param {string} adsPageRoutePath the path of ads page
 * @returns {void}
 */
export function redirectToAdsPageIfCurrentCampaignIsSSCAndUserIsInAdGroupLevel(scope, currentCampaign, currentAdGroup, adsPageRoutePath) {
  const isSmartShoppingCampaign = currentCampaign != null &&
    currentCampaign.CampaignSubType === CampaignSubTypeMapping.ShoppingSmartAds;

  if (isSmartShoppingCampaign && currentAdGroup != null) {
    const { location, history } = scope;
    const { search } = location;
    history.replace({
      pathname: adsPageRoutePath,
      search,
    });
  }
}
